import { sortObjectsByName } from "../helpers/system";
import Cities from "./cities.json";
import Countries from "./country.json";
import Regions from "./regions.json";
import Provinces from "./provinces.json";
import Industries from "./industry.json";
import SubIndustries from "./sub-industry.json";
import IndustriesUno from "./industry-uno.json";
import SubIndustriesUno from "./sub-industry-uno.json";
import IndustriesRfc from "./industry-rfc.json";

Cities.sort(sortObjectsByName);

export const ApplicationYesNoOptions = {
    "yes": "Yes",
    "no": "No",
};

export const ApplicationCitizenshipOptions = {
    "nat_philippines": "Yes",
    "Non-Filipino": "No",
};

export const ApplicationNationalityOptions = {
    "nat_philippines": "Filipino",
    "nat_afghanistan": "Afghanistan",
    "nat_albania": "Albania",
    "nat_algeria": "Algeria",
    "nat_american_samoa": "American Samoa",
    "nat_andorra": "Andorra",
    "nat_angola": "Angola",
    "nat_anguilla": "Anguilla",
    "nat_antigua_and_barbuda": "Antigua And Barbuda",
    "nat_argentina": "Argentine",
    "nat_armenia": "Armenia",
    "nat_aruba": "Aruba",
    "nat_australia": "Australian",
    "nat_austria": "Austrian",
    "nat_azerbaijan": "Azerbaijan",
    "nat_bahamas": "Bahamas",
    "nat_bahrain": "Bahrain",
    "nat_bangladesh": "Bangladeshi",
    "nat_barbados": "Barbados",
    "nat_belarus": "Belarus",
    "nat_belgium": "Belgian",
    "nat_belize": "Belize",
    "nat_benin": "Benin",
    "nat_bermuda": "Bermuda",
    "nat_bhutan": "Bhutan",
    "nat_bolivia": "Bolivian",
    "nat_bosnia_and_herzegovina": "Bosnia and Herzegovina",
    "nat_botswana": "Batswana",
    "nat_brazil": "Brazilian",
    "nat_british_virgin_islands": "British Virgin Islands",
    "nat_brunei_darussalam": "Brunei Darussalam",
    "nat_bulgaria": "Bulgarian",
    "nat_burkina_faso": "Burkina Faso",
    "nat_burundi": "Burundi",
    "nat_cambodia": "Cambodian",
    "nat_cameroon": "Cameroonian",
    "nat_canada": "Canadian",
    "nat_cape_verde": "Cape Verde",
    "nat_cayman_islands": "Cayman Islands",
    "nat_central_african_republic": "Central African Republic",
    "nat_chad": "Chad",
    "nat_chile": "Chilean",
    "nat_china": "Chinese",
    "nat_hong_kong_special_administrative_region_of_china": "Hong Kong Special Administrative Region of China",
    "nat_macao_special_administrative_region_of_china": "Macao Special Administrative Region of China",
    "nat_colombia": "Colombian",
    "nat_comoros": "Comoros",
    "nat_cook_islands": "Cook Islands",
    "nat_costa_rica": "Costa Rican",
    "nat_cote_divoire": "Cote D'ivoire",
    "nat_croatia": "Croatian",
    "nat_cuba": "Cuban",
    "nat_cyprus": "Cyprus",
    "nat_czech_republic": "Czech",
    "nat_democratic_peoples_republic_of_korea": "Democratic People's Republic of Korea",
    "nat_democratic_republic_of_the_congo": "Democratic Republic of the Congo",
    "nat_denmark": "Danish",
    "nat_djibouti": "Djibouti",
    "nat_dominica": "Dominica",
    "nat_dominican_republic": "Dominican",
    "nat_ecuador": "Ecuadorian",
    "nat_egypt": "Egyptian",
    "nat_el_salvador": "Salvadorian",
    "nat_equatorial_guinea": "Equatorial Guinea",
    "nat_eritrea": "Eritrea",
    "nat_estonia": "Estonian",
    "nat_ethiopia": "Ethiopian",
    "nat_faeroe_islands": "Faeroe Islands",
    "nat_falkland_islands_malvinas": "Falkland Islands (Malvinas)",
    "nat_fiji": "Fijian",
    "nat_finland": "Finnish",
    "nat_france": "French",
    "nat_french_guiana": "French Guiana",
    "nat_french_polynesia": "French Polynesia",
    "nat_gabon": "Gabon",
    "nat_gambia": "Gambia",
    "nat_georgia": "Georgia",
    "nat_germany": "German",
    "nat_ghana": "Ghanaian",
    "nat_gibraltar": "Gibraltar",
    "nat_greece": "Greek",
    "nat_greenland": "Greenland",
    "nat_grenada": "Grenada",
    "nat_guadeloupe": "Guadeloupe",
    "nat_guam": "Guam",
    "nat_guatemala": "Guatemalan",
    "nat_guinea": "Guinea",
    "nat_guinea_bissau": "Guinea-Bissau",
    "nat_guyana": "Guyana",
    "nat_haiti": "Haitian",
    "nat_holy_see": "Holy See",
    "nat_honduras": "Honduran",
    "nat_hungary": "Hungarian",
    "nat_iceland": "Icelandic",
    "nat_india": "Indian",
    "nat_indonesia": "Indonesian",
    "nat_iran_islamic_republic_of": "Iranian",
    "nat_iraq": "Iraqi",
    "nat_ireland": "Irish",
    "nat_isle_of_man": "Isle Of Man",
    "nat_israel": "Israeli",
    "nat_italy": "Italian",
    "nat_jamaica": "Jamaican",
    "nat_japan": "Japanese",
    "nat_jordan": "Jordanian",
    "nat_kazakhstan": "Kazakhstan",
    "nat_kenya": "Kenyan",
    "nat_kiribati": "Kiribati",
    "nat_kuwait": "Kuwaiti",
    "nat_kyrgyzstan": "Kyrgyzstan",
    "nat_lao_peoples_democratic_republic": "Lao",
    "nat_latvia": "Latvian",
    "nat_lebanon": "Lebanese",
    "nat_lesotho": "Lesotho",
    "nat_liberia": "Liberia",
    "nat_libyan_arab_jamahiriya": "Libyan",
    "nat_liechtenstein": "Liechtenstein",
    "nat_lithuania": "Lithuanian",
    "nat_luxembourg": "Luxembourg",
    "nat_madagascar": "Malagasy",
    "nat_malawi": "Malawi",
    "nat_malaysia": "Malaysian",
    "nat_maldives": "Maldives",
    "nat_mali": "Malian",
    "nat_malta": "Maltese",
    "nat_marshall_islands": "Marshall Islands",
    "nat_martinique": "Martinique",
    "nat_mauritania": "Mauritania",
    "nat_mauritius": "Mauritius",
    "nat_mayotte": "Mayotte",
    "nat_mexico": "Mexican",
    "nat_micronesia_federated_states_of": "Micronesia, Federated States of",
    "nat_moldova": "Moldova",
    "nat_monaco": "Monaco",
    "nat_mongolia": "Mongolian",
    "nat_montenegro": "Montenegro",
    "nat_montserrat": "Montserrat",
    "nat_morocco": "Moroccan",
    "nat_mozambique": "Mozambican",
    "nat_myanmar": "Myanmar",
    "nat_namibia": "Namibian",
    "nat_nauru": "Nauru",
    "nat_nepal": "Nepalese",
    "nat_netherlands": "Dutch",
    "nat_netherlands_antilles": "Netherlands Antilles",
    "nat_new_caledonia": "New Caledonia",
    "nat_new_zealand": "New Zealand",
    "nat_nicaragua": "Nicaraguan",
    "nat_niger": "Niger",
    "nat_nigeria": "Nigerian",
    "nat_niue": "Niue",
    "nat_norfolk_island": "Norfolk Island",
    "nat_northern_mariana_islands": "Northern Mariana Islands",
    "nat_norway": "Norwegian",
    "nat_occupied_palestinian_territory": "Occupied Palestinian Territory",
    "nat_oman": "Oman",
    "nat_pakistan": "Pakistani",
    "nat_palau": "Palau",
    "nat_panama": "Panamanian",
    "nat_papua_new_guinea": "Papua New Guinea",
    "nat_paraguay": "Paraguayan",
    "nat_peru": "Peruvian",
    "nat_pitcairn": "Pitcairn",
    "nat_poland": "Polish",
    "nat_portugal": "Portuguese",
    "nat_puerto_rico": "Puerto Rico",
    "nat_qatar": "Qatar",
    "nat_republic_of_korea": "Korean",
    "nat_romania": "Romanian",
    "nat_russian_federation": "Russian",
    "nat_rwanda": "Rwanda",
    "nat_saint_helena": "Saint Helena",
    "nat_saint_kitts_and_nevis": "Saint Kitts and Nevis",
    "nat_saint_lucia": "Saint Lucia",
    "nat_saint_pierre_and_miquelon": "Saint Pierre and Miquelon",
    "nat_saint_vincent_and_the_grenadines": "Saint Vincent and the Grenadines",
    "nat_samoa": "Samoa",
    "nat_san_marino": "San Marino",
    "nat_sao_tome_and_principe": "Sao Tome and Principe",
    "nat_saudi_arabia": "Saudi",
    "nat_senegal": "Senegalese",
    "nat_serbia": "Serbian",
    "nat_seychelles": "Seychelles",
    "nat_sierra_leone": "Sierra Leone",
    "nat_singapore": "Singaporean",
    "nat_slovakia": "Slovak",
    "nat_slovenia": "Slovenia",
    "nat_solomon_islands": "Solomon Islands",
    "nat_somalia": "Somalia",
    "nat_south_africa": "South African",
    "nat_spain": "Spanish",
    "nat_sri_lanka": "Sri Lankan",
    "nat_sudan": "Sudanese",
    "nat_suriname": "Suriname",
    "nat_svalbard_and_jan_mayen_islands": "Svalbard and Jan Mayen Islands",
    "nat_swaziland": "Swaziland",
    "nat_sweden": "Swedish",
    "nat_switzerland": "Swiss",
    "nat_syrian_arab_republic": "Syrian",
    "nat_tajikistan": "Tajikistani",
    "nat_thailand": "Thai",
    "nat_the_former_yugoslav_republic_of_macedonia": "The Former Yugoslav Republic of Macedonia",
    "nat_togo": "Togo",
    "nat_tokelau": "Tokelau",
    "nat_tonga": "Tongan",
    "nat_trinidad_and_tobago": "Trinidad and Tobago",
    "nat_tunisia": "Tunisian",
    "nat_turkey": "Turkish",
    "nat_turkmenistan": "Turkmenistan",
    "nat_turks_and_caicos_islands": "Turks and Caicos Islands",
    "nat_tuvalu": "Tuvalu",
    "nat_uganda": "Uganda",
    "nat_ukraine": "Ukrainian",
    "nat_united_arab_emirates": "Emirati",
    "nat_united_kingdom_of_great_britain_and_northern_ireland": "British",
    "nat_united_republic_of_tanzania": "United Republic of Tanzania",
    "nat_united_states_of_america": "American",
    "nat_united_states_virgin_islands": "United States Virgin Islands",
    "nat_uruguay": "Uruguayan",
    "nat_uzbekistan": "Uzbekistan",
    "nat_vanuatu": "Vanuatu",
    "nat_venezuela_bolivarian_republic_of": "Venezuelan",
    "nat_viet_nam": "Vietnamese",
    "nat_wallis_and_futuna_islands": "Wallis and Futuna Islands",
    "nat_western_sahara": "Western Sahara",
    "nat_yemen": "Yemen",
    "nat_zambia": "Zambian",
    "nat_zimbabwe": "Zimbabwean",
};

export const ApplicationBirthPlaceOrigin = { "cty_philippines": "Philippines", "other": "Other countries" };

export const ApplicationNameSuffixOptions = [
    "JR",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII",
    "XIII",
    "XIV",
    "XV",
    "XVI",
    "XVII",
    "XVIII",
    "XIX",
    "XX",
    "XXI",
    "XXII",
    "XXIII",
    "XXIV",
    "XXV",
    "XXVI",
    "XXVII",
    "XXVIII",
    "XXIX",
    "XXX",
    "XXXI",
    "XXXII",
    "XXXIII",
    "XXXIV",
    "XXXV",
    "XXXVI",
    "XXXVII",
    "XXXVIII",
    "XXXIX",
    "XL",
    "XLI",
    "XLII",
    "XLIII",
    "XLIV",
    "XLV",
    "XLVI",
    "XLVII",
    "XLVIII",
    "XLIX",
    "L",
];

export const ApplicationGenderOptions = {
    "male": "Male",
    "female": "Female",
    // 'not-specified': 'Not specified'
};

export const ApplicationCivilStatusOptions = {
    "_default": {
        "single": "Single",
        "married": "Married",
        "widowed": "Widowed",
        "separated": "Separated",
        "others": "Others",
    },
    "SI001": {
        "single": "Single",
        "married": "Married",
        "widowed": "Widowed",
    },
    "EF001": {
        "single": "Single",
        "married": "Married",
        "widowed": "Widowed",
    },
    "RW001": {
        "single": "Single",
        "married": "Married",
        "widowed": "Widow/er",
        "separated": "Separated",
        "others": "Common Law",
    },
    "RW002": {
        "single": "Single",
        "married": "Married",
        "widowed": "Widow/er",
        "separated": "Separated",
        "others": "Common Law",
    },
};

export const ApplicationEmploymentStatusOptions = {
    "_default": {
        "selfemployedbusiness": "I have my own business",
        "privatesector": "I work for a private company",
        "governmentsector": "I work for the government",
        "selfemployedprofessional": "I'm a freelancer",
        "retired": "I'm Retired",
        "others": "Others",
    },
    "PB001_uno": {
        "casualtemporary": "Casual / Temporary",
        "fixedterm": "Fixed-Term",
        "probationary": "Probationary",
        "projectbased": "Project Hire, Project-Based",
        "regular": "Regular",
        "seasonal": "Seasonal",
    },
    "UN002_uno": {
        "casualtemporary": "Casual / Temporary",
        "fixedterm": "Fixed-Term",
        "probationary": "Probationary",
        "projectbased": "Project Hire, Project-Based",
        "regular": "Regular",
        "seasonal": "Seasonal",
    },
    "RW001": {
        "staff": "Staff/Rank & File",
        "supervisory": "Entry Mgt. Level (Supervisory)",
        "managerial": "Middle Mgt. Level (Manegerial)",
        "seniormanagerial": "Senior Mgt. Level (Senior Managerial)",
        "executives": "Executives",
        "directors": "Directors",
        "stockholders": "Stockholders/Business Owner/Partner",
        "others": "Others",
    },
    "RW002": {
        "staff": "Staff/Rank & File",
        "supervisory": "Entry Mgt. Level (Supervisory)",
        "managerial": "Middle Mgt. Level (Manegerial)",
        "seniormanagerial": "Senior Mgt. Level (Senior Managerial)",
        "executives": "Executives",
        "directors": "Directors",
        "stockholders": "Stockholders/Business Owner/Partner",
        "others": "Others",
    },
};

export const ApplicationOccupationOptions = {
    "_default": {
        "privatesector": "Private Sector",
        "retired": "Retired",
        "governmentsector": "Government Sector",
        "selfemployedbusiness": "Self-Employed Business",
        "selfemployedprofessional": "Self-Employed/Professional",
        "otherspleasespecify": "Others",
    },
    "RA001": {
        "privatesector": "Private sector",
        "retired": "Retired",
        "governmentsector": "Government sector",
        "selfemployedbusiness": "Self-employed business",
        "selfemployedprofessional": "Self-employed/Professional",
        "otherspleasespecify": "Others - Please specify",
        "Construcworker": "Construction Worker",
        "cook": "Cook",
        "SeamanDomestic": "Seaman/Domestic helper/OFW",
        "Professional": "Professional",
        "Welder": "Welder",
        "fisher": "Fisherman",
        "carpenter": "Carpenter",
        "clerk": "Clerk",
        "Farmer": "Farmer",
        "HabalPUJtricycleDriver": "Habal-Habal/PUJ/Tricycle Driver",
        "Entrepreneur": "Entrepreneur",
        "sales": "Salesman/Saleslady",
        "factory": "Production/Factory Worker",
        "social": "Social Service Worker",
        "Technician": "Technician",
        "security": "Security Guard",
        "notapplicable": "Not Applicable",
    },
    "PB001_uno": {
        "governmentsector": "Employed - Government",
        "privatesector": "Employed - Private",
        "retired": "Retired",
        "selfemployedbusiness": "Self-Employed / Business Owner",
        "student": "Student",
        "unemployed": "Unemployed",
        "homemaker": "Housewife / House Husband",
        "overseas": "Overseas Filipino Worker",
        "selfemployedprofessional": "Professional",
    },
    "UN002_uno": {
        "governmentsector": "Employed - Government",
        "privatesector": "Employed - Private",
        "retired": "Retired",
        "selfemployedbusiness": "Self-Employed / Business Owner",
        "student": "Student",
        "unemployed": "Unemployed",
        "homemaker": "Housewife / House Husband",
        "overseas": "Overseas Filipino Worker",
        "selfemployedprofessional": "Professional",
    },
    "PB001_sbf": {
        "consultant": "Consultant",
        "contractual": "Contractual",
        "probationary": "Probationary",
        "projecthired": "Project Hired",
        "regular": "Regular",
        "businessowner": "Business Owner",
        "freelance": "Freelance",
        "professional": "Professional",
        "governmentsector": "Government Sector",
    },
    "SB002_sbf": {
        "consultant": "Consultant",
        "contractual": "Contractual",
        "probationary": "Probationary",
        "projecthired": "Project Hired",
        "regular": "Regular",
        "businessowner": "Business Owner",
        "freelance": "Freelance",
        "professional": "Professional",
        "governmentsector": "Government Sector",
    },
};

export const ApplicationOtherIDOptions = {
    "gsis": "GSIS",
    "pag-ibig": "Pag-Ibig Fund",
    "philhealth": "Philhealth",
    "passport": "Passport",
    "drivers_license": "Drivers License",
    "postal": "Postal ID",
    "company_id": "Company ID",
};

export const ApplicationBusinessTypeOptions = {
    _default: {
        "familyowned": "Family Owned",
        "partnership": "Partnership",
        "corporation": "Corporation",
        "soleproprietorship": "Sole proprietorship",
    },
    PB001: {
        "partnership": "Partnership",
        "corporation": "Corporation",
        "soleproprietorship": "Sole proprietorship",
    },
    "UN002_uno": {
        "onepersoncorporation": "One Person Corporation",
        "partnership": "Partnership",
        "corporation": "Corporation",
        "soleproprietorship": "Sole proprietorship",
    },
    EF002: {
        "soleproprietorship": "Sole Proprietorship",
        "partnership": "Partnership",
        "onepersoncorporation": "One Person Corporation",
        "corporation": "Corporation",
        "cooperative": "Cooperative",
    },
};

export const ApplicationBusinessCorporate = ["partnership", "corporation"];

export const ApplicationBusinessIndustryOptions = {
    "_default": Industries,
    "PB001_uno": IndustriesUno,
    "UN002_uno": IndustriesUno,
    "RW001": IndustriesRfc,
    "RW002": IndustriesRfc,
};
export const ApplicationBusinessSubIndustryOptions = {
    "_default": SubIndustries.map((subIndustry) => {
        const { "sub_industry": name, "id": value, industry } = subIndustry;
        return { name, value, industry };
    }),
    "PB001_uno": SubIndustriesUno.map((subIndustry) => {
        const { "id": value, "sub_industry": name, industry = IndustriesUno.map(({ value }) => value) } = subIndustry;
        return { name, value, industry };
    }),
    "UN002_uno": SubIndustriesUno.map((subIndustry) => {
        const { "id": value, "sub_industry": name, industry = IndustriesUno.map(({ value }) => value) } = subIndustry;
        return { name, value, industry };
    }),
};

export const ApplicationBusinessPositionOptions = {
    "chiefexecutiveofficerpresident": "Chief Executive Officer / President",
    "operationshead": "Operations Head",
    "marketinghead": "Marketing Head",
    "financehead": "Finance Head",
    "productshead": "Products Head",
    "hrhead": "HR Head",
    "saleshead": "Sales Head",
    "operationsmanager": "Operations Manager",
    "marketingmanager": "Marketing Manager",
    "financialmanager": "Financial Manager",
    "productmanager": "Product Manager",
    "salesofficer": "Sales Officer",
    "hrofficer": "HR Officer",
    "legalcomplianceofficer": "Legal/Compliance Officer",
    "legalcompliancehead": "Legal/Compliance Head",
    "technologyhead": "Technology Head",
    "technologyofficer": "Technology Officer",
    "otherspleasespecify": "Others - Please specify",
};

export const ApplicationBusinessEstablishmentOptions = {
    "_default": {
        "commercial": "Commercial",
        "residential": "Residential",
        "agricultural": "Agricultural",
    },
    "ZC001": {
        "commercial": "Commercial",
        "residential": "Residential",
    },
    "RC001": {
        "commercial": "Commercial",
        "residential": "Residential",
    },
    "PB001": {
        "commercial": "Commercial",
        "residential": "Residential",
    },
};

export const ApplicationBusinessDigitalPlatformsOptions = {
    "lazada": "Lazada",
    "shopee": "Shopee",
    "instagram": "Instagram",
    "facebook": "Facebook",
    "shopify": "Shopify",
    "carousell": "Carousell",
    "business-website": "Business Website",
    "sentro": "Sentro",
};

export const ApplicationBusinessPaymentChannelsOptions = {
    "gcash": "GCash",
    "paymaya": "Paymaya",
    "coins": "Coins",
    "paypal": "Paypal",
    "online-banking": "Online Banking",
};

export const ApplicationDocumentTypeOptions = {
    "id_photo": "Valid ID of Owner (Primary)",
    // 'attchImgSelfie': 'Selfie Image',
    "dti_certificate": "DTI/SEC Certification (Corporation)",
    "mayors_permit": "Business Permit",
    "sales_proof": "Proof of Sales (6 months)",
    "electricity_bill": "Proof of Billing (with company address)",
    "business_location_photo": "Photo of Business Place",
    //'attchBizPlcPhotoInt': 'Photo of Business Place (interior)',
    //'attchBizPlcPhotoExt': 'Photo of Business Place (exterior)',
    "internet_bill": "Internet Service Provider",
};

export const ApplicationDocumentUploadTypesOptions = {
    attchImgSelfie: "ID Pictures",
    attchImgId: "Valid ID",
    attchBizPermit: "Business Permit",
    attchDTISECCert: "DTI/SEC Certification",
    attchBizPlcPhotoExt: "Photo of Business Place (exterior)",
    attchBizPlcPhotoInt: "Photo of Business Place (Interior)",
    attchImghouse: "Sketch of Residence",
    attchSalesProof: "Proof of Sales (6 months)",
    attchImgIncome: "Proof of Income or Purchase",
    attchBillingProof: "Proof of Billing (Electricity or Water)",
};

export const ApplicationPrimaryBank = {
    "_default": {
        "bank_ubp": "UnionBank of the Philippines (UBP)",
        "bank_aub": "Asia United Bank Corporation (AUB)",
        "bank_bankcom": "Bank of Commerce (BankCom)",
        "bank_bpi": "Bank of the Philippine Islands (BPI)",
        "bank_bdo": "BDO Unibank Inc. (BDO)",
        "bank_chinabank": "China Banking Corporation (CBC)",
        "bank_citibank": "Citibank, N.A. (Citi)",
        "bank_ctbc": "CTBC Bank Philippines Corporation (CBTC)",
        "bank_dbp": "Development Bank of the Philippines (DBP)",
        "bank_eastwest": "East West Banking Corporation (EWBC)",
        "bank_hsbc": "Hongkong & Shanghai Banking Corporation (HSBC)",
        "bank_ing": "ING Bank N.V. (ING)",
        "bank_landbank": "Land Bank of the Philippines (LBP)",
        "bank_maybank": "Maybank Philippines Incorporated (MPI)",
        "bank_metrobank": "Metropolitan Bank & Trust Co. (MBTC)",
        "bank_pbcom": "Philippine Bank of Communications (PBCom)",
        "bank_pnb": "Philippine National Bank (PNB)",
        "bank_philtrust": "Philippine Trust Company (PhilThrust)",
        "bank_veteransbank": "Philippine Veterans Bank (PVB)",
        "bank_rcbc": "Rizal Commercial Banking Corporation (RCBC)",
        "bank_robinsonsbank": "Robinsons Bank Corporation (RBank)",
        "bank_securitybank": "Security Bank Corporation (SBC)",
        "bank_ucpb": "United Coconut Planters Bank (UCPB)",
        "bank_rural-bank-of-bucay": "Rural Bank of Bucay (Abra), Inc.",
        "bank_rural-bank-of-batac": "Rural Bank of Batac, Inc.",
        "bank_rural-bank-of-cabugao": "Rural Bank of Cabugao (Ilocos Sur), Inc.",
        "bank_cordillera-bank": "Cordillera Bank (A Rural Bank), Inc.",
        "bank_rural-bank-of-sta-maria": "Rural Bank of Sta. Maria (Ilocos Sur), Inc.",
        "bank_sadiri-rural-bank": "Sadiri Rural Bank (San Juan, Ilocos Sur), Inc.",
        "bank_vigan-banco-ruralrporada": "Vigan Banco Rural Incorporada",
        "bank_ilocos-consolidated-cooperative-bank": "Ilocos Consolidated Cooperative Bank",
        "bank_rural-bank-of-salcedo": "Rural Bank of Salcedo, Inc.",
        "bank_bannawag-bank": "Bannawag Bank, Inc. (A Rural Bank)",
        "bank_community-rural-bank-of-san-gabriel": "Community Rural Bank of San Gabriel (LU), Inc.",
        "bank_cooperative-bank-of-la-union": "Cooperative Bank of La Union",
        "bank_ludb-bank": "LUDB Bank, Inc, (A Rural Bank)",
        "bank_rang-ay-bank": "Rang-ay Bank (A Rural Bank)",
        "bank_rural-bank-of-agoo": "Rural Bank of Agoo, Inc.",
        "bank_rural-bank-of-bacnotan": "Rural Bank of Bacnotan, Inc.",
        "bank_rural-bank-of-bauang": "Rural Bank of Bauang, Inc.",
        "bank_rural-bank-of-rosario": "Rural Bank of Rosario (La Union), Inc.",
        "bank_rural-bank-of-sudipen": "Rural Bank of Sudipen (La Union), Inc.",
        "bank_bangko-pangasinan": "Bangko Pangasinan (A Rural Bank), Inc.",
        "bank_bhf-rural-bank": "BHF Rural Bank, Inc.",
        "bank_csfirst-bank": "CSFirst Bank Inc.",
        "bank_pangasinan-bank": "Pangasinan Bank (A Rural Bank) Inc.",
        "bank_rural-bank-of-alaminos": "Rural Bank of Alaminos (Pangasinan), Inc.",
        "bank_rural-bank-of-anda": "Rural Bank of Anda (Pangasinan), Inc.",
        "bank_rural-bank-of-balungao": "Rural Bank of Balungao (Pangasinan), Inc.",
        "bank_rural-bank-of-bayambang": "Rural Bank of Bayambang (Pangasinan), Inc.",
        "bank_rural-bank-of-central-pangasinan": "Rural Bank of Central Pangasinan, Inc.",
        "bank_rural-bank-of-mangaldan": "Rural Bank of Mangaldan, Inc.",
        "bank_rural-bank-of-pozorrubio": "Rural Bank of Pozorrubio (Pangasinan), Inc.",
        "bank_rural-bank-of-san-nicolas": "Rural Bank of San Nicolas (Pangasinan), Inc.",
        "bank_rural-bank-of-san-quintin": "Rural Bank of San Quintin, Inc.",
        "bank_banco-sual": "Banco Sual (A Rural Bank), inc.",
        "bank_banco-bakun": "Banco Bakun, Inc. (A Rural Bank)",
        "bank_benguet-center-bank": "Benguet Center Bank, Inc.",
        "bank_cooperative-bank-of-benguet": "Cooperative Bank of Benguet, Inc.",
        "bank_diamond-rural-bank": "Diamond Rural Bank, Inc.",
        "bank_highland-rural-bank": "Highland Rural Bank, Inc.",
        "bank_rural-bank-of-baguio": "Rural Bank of Baguio, Inc.",
        "bank_rural-bank-of-itogon": "Rural Bank of Itogon (Benguet), Inc.",
        "bank_summit-bank": "Summit Bank [Rural Bank of Tublay] (Benguet), Inc.",
        "bank_cooperative-bank-of-mt-province": "Cooperative Bank of Mt. Province",
        "bank_rural-bank-of-bontoc": "Rural Bank of Bontoc (Mt. Province), Inc.",
        "bank_rural-bank-of-sagada": "Rural Bank of Sagada (Mt. Province), Inc.",
        "bank_banco-lagawe": "Banco Lagawe, Inc. (Lagawe Highlands Rural Bank)",
        "bank_first-isabela-cooperative-bank": "FICO Bank (First Isabela Cooperative Bank), Inc.",
        "bank_golden-rural-bank-of-the-philippines": "Golden Rural Bank of the Philippines, Inc.",
        "bank_mallig-plains-rural-bank": "Mallig Plains Rural Bank (Isabela), Inc.",
        "bank_rural-bank-of-alicia": "Rural Bank of Alicia (Isabela), Inc.",
        "bank_common-wealth-rural-bank": "Common Wealth Rural Bank, Inc.",
        "bank_rural-bank-of-cauayan": "Rural Bank of Cauayan, Inc.",
        "bank_bangko-magsaysay": "Bangko Magsaysay (Isabela), Inc. – A Rural Bank",
        "bank_rural-bank-of-ramon": "Rural Bank of Ramon (Isabela), Inc.",
        "bank_rural-bank-of-san-agustin": "Rural Bank of San Agustin (Isabela), Inc.",
        "bank_rural-bank-of-san-manuel": "Rural Bank of San Manuel (Isabela), Inc.",
        "bank_rural-bank-of-san-mateo": "Rural Bank of San Mateo (Isabela), Inc.",
        "bank_united-consumers-rural-bank": "United Consumers Rural Bank, Inc.",
        "bank_north-pacific-banking-corporation":
            "North Pacific Banking Corporation (A Rural Bank of Sta. Maria, Isabela)",
        "bank_cooperative-bank-of-cagayan": "Cooperative Bank of Cagayan, Inc.",
        "bank_providence-rural-bank": "Providence Rural Bank, Inc.",
        "bank_rural-bank-of-gattaran": "Rural Bank of Gattaran, Inc.",
        "bank_rural-bank-of-sanchez-mira": "Rural Bank of Sanchez Mira (Cagayan), Inc.",
        "bank_rural-bank-of-luna": "Rural Bank of Luna (Apayao), Inc.",
        "bank_rural-bank-of-rizal-ka": "Rural Bank of Rizal (Kalinga Apayao), Inc.",
        "bank_rural-bank-of-tabuk": "Rural Bank of Tabuk (Kalinga Apayao), Inc.",
        "bank_agri-business-rural-bank": "Agri-Business Rural Bank, Inc. (AGRIBANK)",
        "bank_cooperative-bank-of-nueva-vizcaya": "Cooperative Bank of Nueva Vizcaya",
        "bank_rural-bank-of-aritao": "Rural Bank of Aritao, Inc.",
        "bank_rural-bank-of-bagabag": "Rural Bank of Bagabag (N.V.), Inc.",
        "bank_rural-bank-of-bambang": "Rural Bank of Bambang (N.V.), Inc.",
        "bank_rural-bank-of-bayombong": "Rural Bank of Bayombong, Inc.",
        "bank_rural-bank-of-dupax": "Rural Bank of Dupax (N.V.), Inc.",
        "bank_rural-bank-of-solano": "Rural Bank of Solano (N.V.), Inc.",
        "bank_rural-bank-of-villaverde": "Rural Bank of Villaverde (N.V.), Inc.",
        "bank_vizcaya-banka-rural-bank": "Vizcaya Bank, A Rural Bank, Inc.",
        "bank_balanga-rural-bank": "Balanga Rural Bank, Inc.",
        "bank_rural-bank-of-abucay": "Banco Abucay, Inc.",
        "bank_rural-bank-of-bagac": "Rural Bank of Bagac (Bataan), Inc.",
        "bank_rural-bank-of-hermosa": "Rural Bank of Hermosa, Inc.",
        //"bank_rural-bank-of-limay": "Rural Bank of Limay (Bataan), Inc.",
        "bank_rural-bank-of-pilar-bataan": "Rural Bank of Pilar (Bataan), Inc.",
        "bank_second-rural-bank-of-valenzuela": "Second Rural Bank of Valenzuela (Metro Manila), Inc.",
        "bank_agricom-rural-bank": "Agricom Rural Bank, Inc.",
        "bank_baliuag-rural-bank": "Baliuag Rural Bank, Inc.",
        "bank_east-coast-rural-bank-of-hagonoy": "East Coast Rural Bank of Hagonoy, Inc.",
        "bank_gateway-rural-bank": "Gateway Rural Bank, Inc. (Gatebank)",
        "bank_meycauayan-second-rural-bank": "Meycauayan Second Rural Bank, Inc.",
        "bank_rural-bank-of-angat": "Rural Bank of Angat (Bulacan), Inc.",
        "bank_rural-bank-of-bustos": "Rural Bank of Bustos, Inc.",
        "bank_rural-bank-of-dona-remedios-trinidad": "Rural Bank of Doña Remedios Trinidad (Bulacan), Inc.",
        "bank_rural-bank-of-pandi": "Rural Bank of Pandi (Bulacan), Inc.",
        "bank_rural-bank-of-plaridel": "Rural Bank of Plaridel (Bulacan), Inc.",
        "bank_rural-bank-of-san-pascual": "Rural Bank of San Pascual, Inc. (RBSPI)",
        "bank_rural-bank-of-san-rafael": "Rural Bank of San Rafael (Bulacan), Inc.",
        "bank_silahis-bank": "Silahis Bank, Inc. (A Rural Bank)",
        "bank_sta-maria-rural-bank": "Sta. Maria Rural Bank, Inc.",
        "bank_rural-bank-of-malolos": "Rural Bank of Malolos, Inc.",
        "bank_banco-rural-de-general-tinio": "Banco Rural de General Tinio (BRGT) Inc.",
        "bank_citizens-rural-bank": "Citizen’s Rural Bank (Cabiao), Inc.",
        "bank_cuyapo-rural-bank": "Cuyapo Rural Bank, Inc.",
        "bank_aliaga-farmers-rural-bank": "Aliaga Farmers Rural Bank, Inc. (Farm Bank)",
        "bank_gm-bank-of-luzon": "GM Bank of Luzon, Inc. (A Rural Bank)",
        "bank_key-rural-bank": "Key Rural Bank, Inc.",
        "bank_masagana-rural-bank": "Masagana Rural Bank (N.E.), Inc.",
        "bank_new-rural-bank-of-san-leonardo": "New Rural Bank of San Leonardo (N.E.), Inc.",
        "bank_rural-bank-of-jaen": "Rural Bank of Jaen, Inc.",
        "bank_profarmers-rural-banking-corporation": "ProFarmers Rural Banking Corporation (Rural Bank of Lupao, Inc.)",
        "bank_rural-bank-of-quezon": "Rural Bank of Quezon (N.E.), Inc.",
        "bank_towncall-rural-bank": "Towncall Rural Bank, Inc.",
        "bank_rural-bank-of-talugtug": "Rural Bank of Talugtug (N.E), Inc.",
        "bank_new-covenant-bank": "New Covenant Bank, Inc.",
        "bank_bangko-nuestra-senora-del-pilar": "Bangko Nuestra Señora del Pilar, Inc.",
        "bank_second-rural-bank-of-san-luis": "Second Rural Bank of San Luis (Bangko San Luis, Inc.)",
        "bank_bof": "BOF Inc. (A Rural Bank)",
        "bank_crown-bank": "Crown Bank, Inc.",
        "bank_guagua-rural-bank": "Guagua Rural Bank, Inc. (GR Bank)",
        "bank_guagua-savers-bank": "Guagua Savers Bank (A Rural Bank), Inc.",
        "bank_rural-bank-of-angeles": "Rural Bank of Angeles (A Subsidiary of Asia United Bank)",
        "bank_rural-bank-of-apalit": "Rural Bank of Apalit, Inc.",
        "bank_rural-bank-of-mabalacat": "Rural Bank of Mabalacat, Inc.",
        "bank_rural-bank-of-mexico": "Rural Bank of Mexico, Inc.",
        "bank_rural-bank-of-porac": "Rural Bank of Porac (Pampanga), Inc.",
        "bank_rural-bank-of-san-luis-pampanga": "Rural Bank of San Luis (Pampanga), Inc.",
        "bank_san-fernando-rural-bank": "San Fernando Rural Bank, Inc. (SAFER BANK)",
        "bank_san-bartolome-rural-bank": "San Bartolome Rural Bank, Inc.",
        "bank_rural-bank-of-sasmuan": "Rural Bank of Sasmuan, Inc. (SASBANK)",
        "bank_saviour-rural-bank": "Saviour Rural Bank, Inc.",
        "bank_advantage-bank-corporation": "Advantage Bank Corporation (Microfinance-Oriented Rural Bank)",
        "bank_camiling-rural-bank": "Camiling Rural Bank, Inc.",
        "bank_rural-bank-of-la-paz": "Rural Bank of La Paz, Inc.",
        "bank_rural-bank-of-pura": "Rural Bank of Pura, Inc.",
        "bank_rural-bank-of-sta-rosa-de-lima": "Rural Bank of Sta. Rosa de Lima, (Paniqui, Tarlac) Inc.",
        "bank_rural-bank-of-victoria": "Rural Bank of Victoria, Inc.",
        "bank_rural-bank-of-sta-ignacia": "Rural Bank of Sta. Ignacia, Inc. (Signabank)",
        "bank_st-michael-rural-bank-of-tarlac": "St. Michael Rural Bank of Tarlac, Inc.",
        "bank_cooperative-bank-of-zambales": "Cooperative Bank of Zambales",
        "bank_countryside-rural-bank-of-palauig": "Countryside Rural Bank of Palauig (Zambales), Inc.",
        "bank_community-rural-bank-of-san-felipe": "Community Rural Bank of San Felipe, Inc.",
        "bank_maharlika-rural-bank": "Maharlika Rural Bank, Inc.",
        "bank_rural-bank-of-cabangan": "Rural Bank of Cabangan (Zambales), Inc.",
        "bank_banko-zambaleno": "Banko Zambaleño, Inc. (BZI) (A Rural Bank)",
        "bank_rural-bank-of-san-marcelino": "Rural Bank of San Marcelino, Inc.",
        "bank_rural-bank-of-san-narciso": "Rural Bank of San Narciso, Inc.",
        "bank_zambales-rural-bank": "Zambales Rural Bank, Inc. (Zambank)",
        "bank_5-speed-rural-bank": "5 Speed Rural Bank, Inc.",
        "bank_rural-bank-of-lipa-city": "Rural Bank of Lipa City, Inc.",
        "bank_caritas-banco-ng-masa": "Caritas Banco ng Masa, Inc.",
        "bank_batangas-rural-bank-for-cooperatives": "Batangas Rural Bank for Cooperatives, Inc.",
        "bank_new-rural-bank-of-agoncillo": "New Rural Bank of Agoncillo, Inc.",
        "bank_classic-rural-bank": "Classic Rural Bank, Inc.",
        "bank_empire-rural-bank": "Empire Rural Bank, Inc.",
        "bank_limcoma-rural-bank": "Limcoma Rural Bank, Inc.",
        "bank_lipa-bank": "Lipa Bank, Incorporated (A Rural Bank)",
        "bank_malarayat-rural-bank": "Malarayat Rural Bank, Inc.",
        "bank_mount-makiling-rural-bank": "Mount Makiling Rural Bank, Inc. (Banco Makiling)",
        "bank_progressive-rural-bank": "Progressive Rural Bank, Inc.",
        "bank_rural-bank-of-alitagtag": "Rural Bank of Alitagtag, Inc.",
        "bank_bolbok-rural-bank": "Bolbok Rural Bank, Inc.",
        "bank_first-bank-of-calaca": "First Bank of Calaca, Inc. (Rural Bank of Calaca, Inc.)",
        "bank_rural-bank-of-cuenca": "Rural Bank of Cuenca, Inc.",
        "bank_rural-bank-of-lemery": "Rural Bank of Lemery, Inc.",
        "bank_mount-carmel-rural-bank": "Mount Carmel Rural Bank, Inc.",
        "bank_rural-bank-of-padre-garcia": "Rural Bank of Padre Garcia, Inc.",
        "bank_rural-bank-of-san-luis-batangas": "Rural Bank of San Luis (Batangas) Inc.",
        "bank_rural-bank-of-taal": "Rural Bank of Taal, Inc.",
        "bank_rural-bank-of-talisay-batangas": "Rural Bank of Talisay (Batangas) , Inc.",
        "bank_summit-rural-bank-of-lipa-city": "Summit Rural Bank of Lipa City, Inc.",
        "bank_sunrise-rural-bank": "Sunrise Rural Bank (Rosario, Batangas), Inc.",
        "bank_utility-bank": "Utility Bank (A Rural Bank)",
        "bank_womens-rural-bank": "Women’s Rural Bank, Inc.",
        "bank_rural-bank-san-antonio": "Rural Bank San Antonio, Inc.",
        "bank_rural-bank-of-maragondon": "Rural Bank of Maragondon, Inc.",
        "bank_bangko-mabuhay": "Bangko Mabuhay (A Rural Bank) Inc.",
        "bank_cebuana-lhuillier-rural-bank": "Cebuana Lhuillier Rural Bank, Inc.",
        "bank_agricultural-bank-of-the-philippines":
            "Agricultural Bank of the Philippines (formerly Central Equity RB, Inc.)",
        "bank_imus-rural-bank": "Imus Rural Bank, Inc.",
        "bank_masuwerte-rural-bank-of-bacoor": "Masuwerte Rural Bank of Bacoor (Cavite), Inc.",
        "bank_own-bankthe-rural-bank-of-cavite-city": "Own Bank, The Rural Bank of Cavite City, Inc.",
        "bank_rural-bank-of-general-trias": "Rural Bank of General Trias, Inc.",
        "bank_rural-bank-of-naic": "Rural Bank of Naic, Inc.",
        "bank_sto-nino-rural-bank": "Sto. Niño Rural Bank (Ternate, Cavite), Inc.",
        "bank_bangko-noveletaa-rural-bank": "Bangko Noveleta, Inc., A Rural Bank",
        "bank_cavite-united-rural-bank-corp": "Cavite United Rural Bank Corp.",
        "bank_first-integrity-bank": "First Integrity Bank, Inc. (Rural Bank of Bailen)",
        "bank_binan-rural-bank": "Biñan Rural Bank, Inc.",
        "bank_card-bank": "CARD Bank, Inc. (A Microfinance-oriented rural bank)",
        "bank_de-la-o-rural-bank": "De La ‘O Rural Bank, Inc.",
        "bank_entrepreneur-rural-bank": "Entrepreneur Rural Bank, Inc.",
        "bank_first-united-farmers-bank": "First United Farmers Bank, Inc.",
        "bank_planbank": "PLANBANK (Rural Bank of Canlubang Planters, Inc.)",
        "bank_provident-rural-bank-of-sta-cruz": "Provident Rural Bank of Sta. Cruz (Laguna) Inc.",
        "bank_rural-bank-of-bay": "Rural Bank of Bay, Inc.",
        "bank_laguna-prestige-banking-corporation": "Laguna Prestige Banking Corporation (A Rural Bank)",
        "bank_banco-de-calamba": "Banco De Calamba, Inc. (A Rural Bank)",
        "bank_rural-bank-of-calauan": "Rural Bank of Calauan, Inc.",
        "bank_rural-bank-of-cavinti": "Rural Bank of Cavinti, Inc.",
        "bank_rural-bank-of-luisiana": "Rural Bank of Luisiana (Laguna) Inc.",
        "bank_rural-bank-of-lumban": "Rural Bank of Lumban (Laguna) Inc.",
        "bank_rural-bank-of-mabitac": "Rural Bank of Mabitac, Inc.",
        "bank_rural-bank-of-magdalena": "Rural Bank of Magdalena (Laguna), Inc.",
        "bank_rural-bank-of-marilag": "Rural Bank of Marilag (Sta. Maria, Lag.), Inc.",
        "bank_rural-bank-of-paete": "Rural Bank of Paete, Inc.",
        "bank_banco-laguna": "Banco Laguna, Inc. (A Rural Bank Since 1965)",
        "bank_rural-bank-of-pangil": "Rural Bank of Pangil (Laguna), Inc.",
        "bank_rural-bank-of-rizal-laguna": "Rural Bank of Rizal (Laguna), Inc.",
        "bank_rural-bank-of-san-lorenzo-ruiz": "Rural Bank of San Lorenzo Ruiz (Siniloan), Inc.",
        "bank_rural-bank-of-seven-lakes": "Rural Bank of Seven Lakes, Inc.",
        "bank_rural-bank-of-sta-rosa": "Rural Bank of Sta. Rosa (Laguna), Inc.",
        "bank_turumba-rural-bank-of-pakil-laguna": "Turumba Rural Bank of Pakil Laguna, Inc.",
        "bank_unilink-bank": "Unilink Bank, Inc. (A Rural Bank)",
        "bank_ormon-bank": "Ormon Bank, Inc.",
        "bank_occidental-mindoro-rural-bank": "Occidental Mindoro Rural Bank, Inc.",
        "bank_tamaraw-rural-bank": "Tamaraw Rural Bank, Inc.",
        "bank_first-mindoro-microfinance-rural-bank": "First Mindoro Microfinance Rural Bank, Inc.",
        "bank_oriental-tamaraw-rural-bank-of-naujan": "Oriental Tamaraw Rural Bank of Naujan, Inc.",
        "bank_rural-bank-of-baco": "Rural Bank of Baco (Oriental Mindoro), Inc.",
        "bank_rural-bank-of-bansud": "Rural Bank of Bansud (Oriental Mindoro), Inc.",
        "bank_banco-de-mindoro": "Banco de Mindoro, Inc. (A Rural Bank)",
        "bank_rural-bank-of-gloria": "Rural Bank of Gloria, Inc.",
        "bank_rural-bank-of-pinamalayan": "Rural Bank of Pinamalayan, Inc.",
        "bank_rural-bank-of-pola": "Rural Bank of Pola (Oriental Mindoro), Inc.",
        "bank_rural-bank-of-puerto-galera": "Rural Bank of Puerto Galera (Oriental Mindoro), Inc.",
        "bank_rural-bank-of-roxas": "Rural Bank of Roxas (Oriental Mindoro), Inc.",
        "bank_rural-bank-of-socorro": "Rural Bank of Socorro (Oriental Mindoro), Inc.",
        "bank_the-country-bank": "The Country Bank",
        "bank_bangko-rural-ng-san-teodoro": "Bangko Rural ng San Teodoro, Inc.",
        "bank_cooperative-bank-of-palawan": "Cooperative Bank of Palawan, Inc.",
        "bank_rural-bank-of-brookes-point": "Rural Bank of Brooke’s Point (Palawan), Inc.",
        "bank_rural-bank-of-cuyo": "Rural Bank of Cuyo (Palawan), Inc.",
        "bank_community-rural-bank-of-romblon": "Community Rural Bank of Romblon (Romblon), Inc.",
        "bank_manor-bank": "Manor Bank (A Rural Bank Corp.)",
        "bank_grand-agri-rural-bank": "Grand Agri Rural Bank, Inc.",
        "bank_mega-rural-bank-of-lucena-city": "Mega Rural Bank of Lucena City, Inc.",
        "bank_quezon-capital-rural-bank": "Quezon Capital Rural Bank, Inc. (QCRB)",
        "bank_cooperative-bank-of-quezon-province": "Cooperative Bank of Quezon Province (CBQP)",
        "bank_rural-bank-of-mauban": "Rural Bank of Mauban, Inc.",
        "bank_rural-bank-of-atimonan": "Rural Bank of Atimonan, Inc.",
        "bank_rural-bank-of-candelaria": "Rural Bank of Candelaria, Inc.",
        "bank_rural-bank-of-dolores": "Rural Bank of Dolores (Quezon), Inc.",
        "bank_rural-bank-of-general-luna": "Rural Bank of General Luna (Quezon), Inc.",
        "bank_rural-bank-of-infanta": "Rural Bank of Infanta, Inc.",
        "bank_rural-bank-of-lucban": "Rural Bank of Lucban (Quezon), Inc.",
        "bank_rural-bank-of-pagbilao": "Rural Bank of Pagbilao, Inc.",
        "bank_rural-bank-of-sampaloc": "Rural Bank of Sampaloc (Quezon), Inc.",
        "bank_tiaong-rural-bank": "Tiaong Rural Bank, Inc.",
        "bank_universal-rural-bank-of-lopez": "Universal Rural Bank of Lopez (Quezon), Inc.",
        "bank_rural-bank-of-casiguran": "Rural Bank of Casiguran, Inc.",
        "bank_rural-bank-of-maria-aurora": "Rural Bank of Maria Aurora (Aurora), Inc.",
        "bank_aurora-bank": "Aurora Bank (A Microfinance-Oriented Rural Bank), Inc.",
        "bank_binangonan-rural-bank": "Binangonan Rural Bank, Inc.",
        "bank_filidian-rural-bank-of-antipolo": "Filidian Rural Bank of Antipolo, Inc.",
        "bank_rural-bank-of-angono": "Rural Bank of Angono, Inc.",
        "bank_rural-bank-of-cardona": "Rural Bank of Cardona (Rizal), Inc.",
        "bank_rural-bank-of-montalban": "Rural Bank of Montalban, Inc.",
        "bank_innovative-bank": "Innovative Bank Inc. (A Rural Bank)",
        "bank_rural-bank-of-antipolo": "Rural Bank of Antipolo, Inc.",
        "bank_tanay-rural-bank": "Tanay Rural Bank, Inc.",
        "bank_rizal-bank": "Rizal Bank Inc. – A Microfinance-Oriented Rural Bank",
        "bank_banco-santiago-de-libon": 'Banco Santiago de Libon, Inc. "A Rural Bank"',
        "bank_cagsawa-rural-bank": "Cagsawa Rural Bank, Inc.",
        "bank_camalig-bank": "Camalig Bank, Inc. (A Rural Bank)",
        "bank_rural-bank-of-guinobatan": "Rural Bank of Guinobatan, Inc.",
        "bank_rural-bank-of-capalonga": "Rural Bank of Capalonga (Cam. Norte), Inc.",
        "bank_rural-bank-of-jose-panganiban": "Rural Bank of Jose Panganiban (Camarines Norte) Inc.",
        "bank_rural-bank-of-paracale": "Rural Bank of Paracale (Cam. Norte), Inc.",
        "bank_banco-san-vicente": "Banco San Vicente, Inc. (A Rural Bank)",
        "bank_bangko-rural-ng-magarao": "Bangko Rural ng Magarao (Cam. Sur), Inc.",
        "bank_first-naga-rural-bank": "First Naga Rural Bank, Inc.",
        "bank_municipal-rural-bank-of-libmanan": "Municipal Rural Bank of Libmanan (Cam. Sur), Inc.",
        "bank_municipal-rural-bank-of-nabua": "Municipal Rural Bank of Nabua, (Camarines Sur) Inc.",
        "bank_southeast-country-bank": "Southeast Country Bank, Inc. (A Rural Bank)",
        "bank_rural-bank-of-pamplona": "Rural Bank of Pamplona (Cam. Sur), Inc.",
        "bank_rural-bank-of-san-fernando": "Rural Bank of San Fernando (Cam. Sur), Inc.",
        "bank_rural-bank-of-san-jose": "Rural Bank of San Jose (Cam. Sur), Inc.",
        "bank_rural-bank-of-sipocot": "Rural Bank of Sipocot (Cam. Sur), Inc.",
        "bank_rural-bank-of-tigaon": "Rural Bank of Tigaon (Cam. Sur), Inc.",
        "bank_bangko-rural-ng-pasacao": "Bangko Rural ng Pasacao, Inc.",
        "bank_ardcibank": "ARDCIBank, Inc. (A Rural Bank)",
        "bank_rural-bank-of-san-jacinto": "Rural Bank of San Jacinto (Masbate), Inc.",
        "bank_rural-bank-of-irosin": "Rural Bank of Irosin, Inc.",
        "bank_rural-bank-of-pilar-sorsogon": "Rural Bank of Pilar (Sorsogon), Inc.",
        "bank_rural-bank-of-donsol": "Rural Bank of Donsol (Sorsogon), Inc.",
        "bank_rural-bank-of-altavas": "Rural Bank of Altavas, Inc.",
        "bank_rural-bank-of-ibajay": "Rural Bank of Ibajay, Inc.",
        "bank_rural-bank-of-makato": "Rural Bank of Makato, Inc.",
        "bank_rural-bank-of-new-washington": "Rural Bank of New Washington, Inc.",
        "bank_rural-bank-of-bugasong": "Rural Bank of Bugasong, (Antique) Inc.",
        "bank_rural-bank-of-sibalom": "Rural Bank of Sibalom, Inc.",
        "bank_rural-bank-of-tibiao": "Rural Bank of Tibiao (Antique), Inc.",
        "bank_farmbank": "Farmbank, Inc. (A Rural Bank)",
        "bank_rural-bank-of-cuartero": "Rural Bank of Cuartero, Inc.",
        "bank_rural-bank-of-jamindan": "Rural Bank of Jamindan, Inc.",
        "bank_rural-bank-of-mambusao": "Rural Bank of Mambusao, Inc.",
        "bank_first-midland-rural-bank": "First Midland Rural Bank, Inc.",
        "bank_janiuay-rural-bank": "Janiuay Rural Bank, Inc.",
        "bank_lifebank": "LifeBank – A Rural Bank",
        "bank_progressive-bank": "Progressive Bank, Inc. (A Rural Bank)",
        "bank_racsos-bank": "Racso’s Bank, Inc. (A Rural Bank)",
        "bank_rural-bank-of-alimodian": "Rural Bank of Alimodian (Iloilo), Inc.",
        "bank_anilao-bank": "Anilao Bank (Rural Bank of Anilao [Iloilo], Inc.)",
        "bank_rural-bank-of-barotac-nuevo": "Rural Bank of Barotac Nuevo, Inc.",
        "bank_rural-bank-of-cabatuan": "Rural Bank of Cabatuan (Iloilo), Inc.",
        "bank_rural-bank-of-calinog": "Rural Bank of Calinog (Iloilo), Inc.",
        "bank_rural-bank-of-dumangas": "Rural Bank of Dumangas, Inc.",
        "bank_rbg-imperial-bank": "RBG Imperial Bank, Inc. (A Rural Bank)",
        "bank_rural-bank-of-iloilo-city": "Rural Bank of Iloilo City, Inc.",
        "bank_rural-bank-of-miag-ao": "Rural Bank of Miag-ao (Iloilo), Inc.",
        "bank_rural-bank-of-oton": "Rural Bank of Oton (Iloilo), Inc.",
        "bank_rural-bank-of-pavia": "Rural Bank of Pavia (Iloilo), Inc.",
        "bank_rural-bank-of-pototan": "Rural Bank of Pototan, Inc.",
        "bank_rural-bank-of-san-miguel": "Rural Bank of San Miguel (Iloilo), Inc.",
        "bank_rural-bank-of-sta-barbara": "Rural Bank of Sta. Barbara (Iloilo), Inc.",
        "bank_rural-bank-of-tigbauan": "Rural Bank of Tigbauan, Inc.",
        "bank_rural-bank-of-zarraga": "Rural Bank of Zarraga (Iloilo), Inc.",
        "bank_valiant-bank": "Valiant Bank, Inc. (A Rural Bank)",
        "bank_rural-bank-of-leganes": "Rural Bank of Leganes, Inc.",
        "bank_bangko-buena-condosolidated": "Bangko Buena Condosolidated, Inc. (A Rural Bank)",
        //"bank_opportunity-kauswagan-bank": "Opportunity Kauswagan Bank, Inc.",
        "bank_banco-de-arevalo": "Banco de Arevalo, Inc. (A Rural Bank)",
        "bank_first-community-bank": "First Community Bank, Inc. (Rural Bank)",
        "bank_first-state-rural-bank": "First State Rural Bank, Inc.",
        "bank_rural-bank-of-bacolod-city": "Rural Bank of Bacolod City, Inc.",
        "bank_rural-bank-of-cadizinc": "Rural Bank of Cadiz, inc.",
        "bank_rural-bank-of-escalante": "Rural Bank of Escalante, Inc.",
        "bank_rural-bank-of-ilog": "Rural Bank of Ilog (Negros Occ.), Inc.",
        "bank_rural-bank-of-manapla": "Rural Bank of Manapla (Negros Occ.), Inc.",
        "bank_marayo-bank": "Marayo Bank, Inc. (A Rural Bank)",
        "bank_rural-bank-of-sagay": "Rural Bank of Sagay, Inc.",
        "bank_rural-bank-of-silay-city": "Rural Bank of Silay City, Inc.",
        "bank_rural-bank-of-talisay-negros": "Rural Bank of Talisay, Inc.",
        "bank_dungganon-bank": "Dungganon Bank (A Microfinance Rural Bank) Inc.",
        "bank_cooperative-bank-of-bohol": "Cooperative Bank of Bohol",
        "bank_rural-bank-of-loon": "Rural Bank of Loon (Bohol), Inc.",
        "bank_rural-bank-of-loboc": "Rural Bank of Loboc, Inc.",
        "bank_aspac-rural-bank": "ASPAC Rural Bank, Inc.",
        "bank_cooperative-bank-of-cebu": "Cooperative Bank of Cebu, Inc.",
        "bank_community-rural-bank-of-catmon": "Community Rural Bank of Catmon (Cebu), Inc.",
        "bank_community-rural-bank-of-medellin": "Community Rural Bank of Medellin (Cebu), Inc.",
        "bank_first-agro-industrial-rural-bank": "First-Agro Industrial Rural Bank, Inc. (FAIRBANK)",
        "bank_frontier-rural-bank": "Frontier Rural Bank, Inc.",
        "bank_national-teachers-employees-cooperative-bank": "National Teachers & Employees Cooperative Bank",
        "bank_rng-coastal-bank": "RNG Bank",
        "bank_rural-bank-of-barili": "Rural Bank of Barili (Cebu), Inc.",
        "bank_rural-bank-of-bogo": "Rural Bank of Bogo (Cebu), Inc.",
        "bank_bankways": "Bankways, Inc., (A Rural Bank)",
        "bank_mactan-rural-bank": "Mactan Rural Bank (Lapu-Lapu City), Inc.",
        "bank_rural-bank-of-madridejos": "Rural Bank of Madridejos (Cebu), Inc.",
        "bank_rural-bank-of-mandaue": "Rural Bank of Mandaue, Inc.",
        "bank_rural-bank-of-oslob": "Rural Bank of Oslob (Cebu), Inc.",
        "bank_rural-bank-of-talisay-cebu": "Rural Bank of Talisay (Cebu), Inc.",
        "bank_sugbuanon-rural-bank": "Sugbuanon Rural Bank, Inc.",
        "bank_upland-rural-bank-of-dalaguete": "Upland Rural Bank of Dalaguete (Cebu) Inc.",
        // "bank_banco-maximo": "Banco Maximo, Inc. (A Rural Bank)",
        "bank_rural-bank-of-ronda": "Rural Bank of Ronda, Inc.",
        "bank_dumaguete-rural-bank": "Dumaguete Rural Bank, Inc.",
        "bank_cooperative-bank-of-negros-oriental": "Cooperative Bank of Negros Oriental",
        "bank_rural-bank-of-bacong": "Rural Bank of Bacong, (Negros Or.) Inc.",
        "bank_rural-bank-of-guihulngan": "Rural Bank of Guihulngan, Inc.",
        "bank_rural-bank-of-sta-catalina": "Rural Bank of Sta. Catalina (Negros Or.), Inc.",
        "bank_rural-bank-of-tanjay": "Rural Bank of Tanjay, Inc.",
        "bank_sg-bank": "SG Bank – A Rural Bank, Inc.",
        "bank_rural-bank-of-amlan": "Rural Bank of Amlan (Negros Or.), Inc.",
        "bank_rural-bank-of-larena": "Rural Bank of Larena (Siquijor), Inc.",
        "bank_rural-bank-of-bato": "Rural Bank of Bato (Leyte), Inc.",
        "bank_rural-bank-of-dulag": "Rural Bank of Dulag (Leyte), Inc.",
        "bank_rural-bank-of-hilongos": "Rural Bank of Hilongos (Leyte), Inc.",
        "bank_rural-bank-of-hindang": "Rural Bank of Hindang (Leyte), Inc.",
        "bank_rural-bank-of-mahaplag": "Rural Bank of Mahaplag, Inc.",
        "bank_rural-bank-of-matag-ob": "Rural Bank of Matag-ob, Inc.",
        "bank_bank-of-ormoc": "Bank of Ormoc, Inc. (A Rural Bank)",
        "bank_rural-bank-of-hinundayan": "Rural Bank of Hinundayan (Southern Leyte), Inc.",
        "bank_rural-bank-of-malitbog": "Rural Bank of Malitbog (Southern Leyte), Inc.",
        "bank_rural-bank-of-san-juan": "Rural Bank of San Juan (Southern Leyte), Inc.",
        "bank_rural-bank-of-maasin": "Rural Bank of Maasin (Southern Leyte), Inc.",
        "bank_rural-bank-of-guiuan": "Rural Bank of Guiuan (Eastern Samar), Inc.",
        "bank_far-eastern-bank": "Far Eastern Bank (A Rural Bank)",
        "bank_rural-bank-of-basey": "Rural Bank of Basey. Inc.",
        "bank_rural-bank-of-calbayog-city": "Rural Bank of Calbayog City, Inc.",
        "bank_rural-bank-of-gandara": "Rural Bank of Gandara (Samar), Inc.",
        "bank_community-rural-bank-of-dapitan-city": "Community Rural Bank of Dapitan City, Inc.",
        "bank_banco-dipolog": "Banco Dipolog, Inc. (A Rural Bank)",
        "bank_katipunan-bank": 'Katipunan Bank (ZN) Inc. "A Rural Bank"',
        "bank_rural-bank-of-labason": "Rural Bank of Labason (ZN), Inc.",
        "bank_rural-bank-of-liloy": "Rural Bank of Liloy (ZN), Inc.",
        "bank_rural-bank-of-manukan": "Rural Bank of Manukan (ZN), Inc.",
        "bank_rural-bank-of-rizal-zn": "Rural Bank of Rizal (ZN), Inc.",
        "bank_rural-bank-of-salug": "Rural Bank of Salug (ZN), Inc.",
        "bank_rural-bank-of-siocon": "Rural Bank of Siocon (ZN), Inc.",
        "bank_zamboanga-del-norte-cooperative-bank": "Zamboanga del Norte Cooperative Bank",
        "bank_rural-bank-of-kabasalan": "Rural Bank of Kabasalan (Zamboanga Del Sur) Inc.",
        "bank_rural-bank-of-pagadian": "Rural Bank of Pagadian, Inc.",
        "bank_salug-valley-rural-bank": "Salug Valley Rural Bank, Inc.",
        "bank_zamboanga-city-rural-bank": "Zamboanga City Rural Bank, Inc.",
        "bank_banco-cooperativa-de-zamboanga": "Banco Cooperativa de Zamboanga",
        "bank_rural-bank-of-bonifacio": "Rural Bank of Bonifacio (Misamis Occidental), Inc.",
        "bank_rural-bank-of-jimenez": "Rural Bank of Jimenez (Mis Occ), Inc.",
        "bank_rural-bank-of-lopez-jaena": "Rural Bank of Lopez Jaena (Misamis Occidental), Inc.",
        "bank_rural-bank-of-pana-on": "Rural Bank of Pana-on (Misamis Occidental), Inc.",
        "bank_bank-of-hope": "Bank of Hope, Inc.",
        "bank_rural-bank-of-tangub-city": "Rural Bank of Tangub City, Inc.",
        "bank_misamis-bank": "Misamis Bank Inc. (A Rural Bank)",
        "bank_rural-bank-of-maigo": "Rural Bank of Maigo (Lanao del Norte), Inc.",
        "bank_rural-bank-of-gingoog": "Rural Bank of Gingoog, Inc.",
        "bank_cooperative-bank-of-misamis-oriental": "Cooperative Bank of Misamis Oriental",
        "bank_naawan-community-rural-bank": "Naawan Community Rural Bank (Misamis Oriental), Inc.",
        "bank_rural-bank-of-el-salvador": "Rural Bank of El Salvador (Misamis Oriental), Inc.",
        "bank_rural-bank-of-gitagum": "Rural Bank of Gitagum, Inc.",
        "bank_rural-bank-of-initao": "Rural Bank of Initao, Inc.",
        "bank_rural-bank-of-medina": "Rural Bank of Medina (Mis Or), Inc.",
        "bank_rbt-bank": "RBT Bank, Inc. (A Rural Bank)",
        "bank_secured-bank": "Secured Bank, Inc. (A Rural Bank)",
        "bank_south-bank": "South Bank, Inc. (A Rural Bank)",
        "bank_palm-tree-bank": "Palm Tree Bank, Inc. (Rural Bank of Cotobato, Inc.)",
        "bank_binhi-rural-bank": "Binhi Rural Bank, Inc. (Formerly Rural Bank of Balingasag (Mis. Or.), Inc.)",
        "bank_d-asian-hills-bank": "D’ Asian Hills Bank, Inc. (A Rural Bank) (DAHBI)",
        "bank_bukidnon-coperative-bank": "Bukidnon Coperative Bank (BCB)",
        "bank_malaybalay-rural-bank": "Malaybalay Rural Bank, Inc.",
        "bank_bukidnon-bank": "Bukidnon Bank (A Rural Bank), Inc.",
        "bank_rural-bank-of-kibawe": "Rural Bank of Kibawe, Inc.",
        "bank_rural-bank-of-manolo-fortich": "Rural Bank of Manolo Fortich, Inc.",
        "bank_butuan-city-rural-bank": "Butuan City Rural Bank, Inc.",
        "bank_peoples-bank-of-caraga": "People’s Bank of CARAGA, (A Rural Bank) Inc.",
        "bank_rural-bank-of-loreto": "Rural Bank of Loreto, Inc.",
        "bank_rural-bank-of-placer": "Rural Bank of Placer, Inc.",
        "bank_bangko-carrascal": "Bangko Carrascal Inc. (A Rural Bank)",
        "bank_cantilan-bank": "Cantilan Bank, Inc. (A Rural Bank)",
        "bank_rural-bank-of-lanuza": "Rural Bank of Lanuza (Surigao del Sur), Inc.",
        "bank_rural-bank-of-tandag": "Rural Bank of Tandag (SDS), Inc.",
        "bank_century-rural-bank": "Century Rural Bank, Inc.",
        "bank_money-mall-rural-bank": "Money Mall Rural Bank, Inc.",
        "bank_rural-bank-of-compostela": "Rural Bank of Compostela (Davao del Norte), Inc.",
        "bank_rural-bank-of-kapalong": "Rural Bank of Kapalong (Davao del Norte), Inc.",
        "bank_first-tagum-rural-bank": "First Tagum Rural Bank, Inc.",
        "bank_baybank": "Baybank, Inc.",
        "bank_rural-bank-of-mati": "Rural Bank of Mati, Inc.",
        "bank_consolidated-cooperative-bank": "Consolidated Cooperative Bank (CCB)",
        "bank_one-network-bank": "One Network Bank, Inc. (A Rural Bank of BDO)",
        "bank_rural-bank-of-digos": "Rural Bank of Digos, Inc.",
        "bank_cooperative-bank-of-cotabato": "Cooperative Bank of Cotabato",
        "bank_partner-rural-bank": "Partner Rural Bank (Cotabato), Inc.",
        "bank_rural-bank-of-midsayap": "Rural Bank of Midsayap, Inc.",
        "bank_rural-bank-of-datu-paglas": "Rural Bank of Datu Paglas, Inc.",
        "bank_rural-bank-of-lebak": "Rural Bank of Lebak (Sultan Kudarat), Inc.",
        "bank_rural-bank-of-president-quirino": "Rural Bank of President Quirino (Sultan Kudarat) Inc.",
        "bank_bagong-bangko-rural-ng-malabang": "Bagong Bangko Rural ng Malabang, Inc.",
        "bank_peoples-rural-bank": "People’s Rural Bank (Gen. Santos City), Inc.",
        "bank_rural-bank-of-norala": "Rural Bank of Norala (South Cotabato), Inc.",
        "bank_rural-bank-of-polomolok": "Rural Bank of Polomolok, Inc.",
        "bank_rural-bank-of-alabel": "Rural Bank of Alabel (Sarangani), Inc.",
        "bank_rural-bank-of-kiamba": "Rural Bank of Kiamba (Sarangani), Inc.",
        "bank_banco-alabang": "Banco Alabang, Inc. (A Rural Bank)",
        "bank_smart-bank": "Smart Bank (A Rural Bank, Inc.)",
        "bank_ama-rural-bank-of-mandaluyong": "AMA Rural Bank of Mandaluyong, Inc.",
        "bank_bangko-pasig": "Bangko Pasig (Rural Bank)",
        "bank_east-west-rural-bank": "East West Rural Bank, Inc.",
        "bank_rodriguez-rural-bank": "Rodriguez Rural Bank, Inc.",
        "bank_metro-south-cooperative-bank": "Metro South Cooperative Bank, Inc.",
        "bank_mvsm-bank": "MVSM Bank (A Rural Bank Since 1953) Inc.",
        "bank_country-builders-bank": "Country Builders Bank, Inc.",
        "bank_enterprise-capital-bank": "Enterprise Capital Bank, Inc. (Taguig Rural Bank)",
        "bank_san-francisco-del-monte-rural-bank": "San Francisco del Monte Rural Bank, Inc.",
        "bank_1st-macro-bank": "1st Macro Bank, Inc. (A Rural Bank)",
        "bank_insular-savers-bank": "Insular Savers Bank (A Rural bank), Inc.",
        "bank_rural-bank-of-caloocan": "Rural Bank of Caloocan, Inc.",
        "others": "Others",
    },
    "PB001_uno": {
        "bank_aub": "Asia United Bank Corporation",
        "bank_bankcom": "Bank of Commerce",
        "bank_bpi": "Bank of the Philippine Islands",
        "bank_bdo": "BDO Unibank Inc.",
        "bank_chinabank": "China Banking Corporation",
        "bank_citibank": "Citibank, N.A.",
        "bank_ctbc": "CTBC Bank Philippines Corporation",
        "bank_dbp": "Development Bank of the Philippines",
        "bank_eastwest": "East West Banking Corporation",
        "bank_hsbc": "Hongkong & Shanghai Banking Corporation",
        "bank_ing": "ING Bank N.V.",
        "bank_landbank": "Land Bank of the Philippines",
        "bank_maybank": "Maybank Philippines Incorporated",
        "bank_metrobank": "Metropolitan Bank & Trust Co.",
        "bank_pbcom": "Philippine Bank of Communications",
        "bank_pnb": "Philippine National Bank",
        "bank_philtrust": "Philippine Trust Company",
        "bank_veteransbank": "Philippine Veterans Bank",
        "bank_rcbc": "Rizal Commercial Banking Corporation",
        "bank_robinsonsbank": "Robinsons Bank Corporation",
        "bank_securitybank": "Security Bank Corporation",
        "bank_ubp": "UnionBank of the Philippines",
        "bank_ucpb": "United Coconut Planters Bank",
        "bank_1valley-bank": "1st Valley Bank",
        "bank_psbank": "The Philippine Savings Bank",
        "others": "Others",
    },
    "UN002_uno": {
        "bank_aub": "Asia United Bank Corporation",
        "bank_bankcom": "Bank of Commerce",
        "bank_bpi": "Bank of the Philippine Islands",
        "bank_bdo": "BDO Unibank Inc.",
        "bank_chinabank": "China Banking Corporation",
        "bank_citibank": "Citibank, N.A.",
        "bank_ctbc": "CTBC Bank Philippines Corporation",
        "bank_dbp": "Development Bank of the Philippines",
        "bank_eastwest": "East West Banking Corporation",
        "bank_hsbc": "Hongkong & Shanghai Banking Corporation",
        "bank_ing": "ING Bank N.V.",
        "bank_landbank": "Land Bank of the Philippines",
        "bank_maybank": "Maybank Philippines Incorporated",
        "bank_metrobank": "Metropolitan Bank & Trust Co.",
        "bank_pbcom": "Philippine Bank of Communications",
        "bank_pnb": "Philippine National Bank",
        "bank_philtrust": "Philippine Trust Company",
        "bank_veteransbank": "Philippine Veterans Bank",
        "bank_rcbc": "Rizal Commercial Banking Corporation",
        "bank_robinsonsbank": "Robinsons Bank Corporation",
        "bank_securitybank": "Security Bank Corporation",
        "bank_ubp": "UnionBank of the Philippines",
        "bank_ucpb": "United Coconut Planters Bank",
        "bank_1valley-bank": "1st Valley Bank",
        "bank_psbank": "The Philippine Savings Bank",
        "others": "Others",
    },
};

export const ApplicationEducationalAttainment = {
    "_default": {
        "elemenGrad": "Elementary Graduate",
        "college": "College Level",
        "elementary": "Elementary Level",
        "HighScLevel": "Highschool Level",
        "ColleGrad": "College Graduate ",
        "vocational": "Vocational",
        "HighSchGrad": "Highschool Graduate ",
        "PostGrad": "Post Graduate",
        "nodegree": "No Degree",
        "others": "Others",
    },
    "PB001_sbf": {
        "underGrad": "UNDERGRADUATE",
        "collegeGrad": "COLLEGE",
        "phdGrad": "POST GRADUATE",
        "vacationalGrad": "VOCATIONAL",
    },
    "SB002_sbf": {
        "underGrad": "UNDERGRADUATE",
        "collegeGrad": "COLLEGE",
        "phdGrad": "POST GRADUATE",
        "vacationalGrad": "VOCATIONAL",
    },
    "RW001": {
        "elementary": "Elementary",
        "highschool": "High School",
        "vocational": "Vocational",
        "college": "College",
        "postgraduate": "Post-Graduate",
        "undergraduate": "College Undergraduate",
        "hsundergraduate": "Elementary / HS Undergraduate",
    },
    "RW002": {
        "elementary": "Elementary",
        "highschool": "High School",
        "vocational": "Vocational",
        "college": "College",
        "postgraduate": "Post-Graduate",
        "undergraduate": "College Undergraduate",
        "hsundergraduate": "Elementary / HS Undergraduate",
    },
};

export const ApplicationValidIDs = {
    "passport": "Passport",
    "ofw-id": "OFW ID",
    "prc-id": "PRC ID",
    "owwa-id": "OWWA ID",
    "nbi-clearance": "NBI Clearance",
    "postal-id": "Postal ID (Digitized)",
    "drivers-license": "Driver's License",
    "tin-id": "TIN (Digitized)",
    "sss-umid": "SSS ID/UMID",
    "gsis-id": "GSIS e-card/GSIS ID",
    "company-id": "Company ID",
    "school-id": "School ID",
    "ibp-id": "IBP ID",
    "senior-citizen-card": "Senior Citizen Card",
    "goccid": "Gov't office and GOCCID",
    "philhealth-card": "PhilHealth Insurance Card",
    "seamans-book": "Seaman's book",
    "voters-id": "Voter's ID",
};

export const ApplicationValidIDTypes = {
    "idno": "ID No",
    "passport": "Passport",
    "DriverLicense": "DriverLicense",
    "sssumd": "SSS UMD",
    "prcid": "PRC ID",
    "voterID": "Voter's ID",
    "seniorID": "Senior Citizen ID",
    "pwdID": "PWD ID",
    "philID": "Philhealth ID",
    "TINcard": "TIN Card",
    "postalID": "Postal ID",
    "GSISeCard": "GSIS eCard",
    "NBIClearance": "NBI Clearance",
    "PoliceClearance": "Police Clearance",
    "Cedula": "Cedula",
};

export const ApplicationHomeOwnership = {
    "owned": "Owned",
    "ownedmortgaged": "Owned-mortgaged",
    "rented": "Rented",
    "livingwithrelatives": "Living with Relatives",
    "others": "Others",
    "housecaretaker": "House Caretaker",
};

export const ApplicationReferenceRelationsShip = {
    "parent": "Parent",
    "spouse": "Spouse",
    "child": "Child",
    "friend": "Friend",
};

export const ApplicationLoanTypeOptions = {
    "individual": "Individual",
    "partnership": "Partnership",
    "corporation": "Corporation",
    "soleproprietorship": "Sole proprietorship",
};

export const ApplicationProvinceOptions = {
    "_default": Provinces,
    "PB001_uno": Regions,
    "UN002_uno": Regions,
};

export const ApplicationReligionOptions = {
    "catholic": "Catholic",
    "christian": "Christian",
    "nonchristian": "Non-Christian",
    "islam": "Islam",
};

export const ApplicationIncomeSourceOptions = {
    "employmentincome": "Employment Income/Salary",
    "businessincome": "Business Income",
    "remittances": "Remittances/Allotment",
    "pension": "Pension/Retirement",
    "commisions": "Commissions/Incentives/Dividends",
};

export const ApplicationLoanPurposeOptions = {
    "financing": "FINANCING/ACQUISITION OF UNIT/ITEM",
    "business": "BUSINESS/WORKING CAPITAL",
    "personal": "MULTI-PURPOSE/PERSONAL",
};

export const ApplicationCollateralOptions = {
    "motorcycles": "MOTORCYCLES",
    "vehiclepersonal": "VEHICLE - PERSONAL",
    "vehicletrucks": "VEHICLE - TRUCKS",
    "realestate": "REAL ESTATE",
};

export const ApplicationRealEstateOptions = {
    "residential": "Residential",
    "commercial": "Commercial",
    "industrial": "Industrial",
    "agricultural": "Agricultural",
    "mixeduse": "Mixed Use",
};

export const OptionsGroupMap = {
    "noyes_options": ApplicationYesNoOptions,
    "gender_option": ApplicationGenderOptions,
    "occupation_option": ApplicationOccupationOptions,
    "position_option": ApplicationBusinessPositionOptions,
    "personPriBank_options": ApplicationPrimaryBank,
    "natureOfBiz_option": ApplicationBusinessIndustryOptions,
    "natureOfSubBiz_option": ApplicationBusinessSubIndustryOptions,
    "personHighestQualification_options": ApplicationEducationalAttainment,
    "personIDTypeD_options": ApplicationValidIDTypes,
    "ownership_option": ApplicationHomeOwnership,
    "city_option": Cities,
    "country_options": Countries,
    "personRelationD1_options": ApplicationReferenceRelationsShip,
    "personRelationD2_options": ApplicationReferenceRelationsShip,
    "personRelationD3_options": ApplicationReferenceRelationsShip,
    "customerCat_option": ApplicationLoanTypeOptions,
    "province_option": ApplicationProvinceOptions,
    "religion_option": ApplicationReligionOptions,
    "incomeSource_option": ApplicationIncomeSourceOptions,
    "employmentStatus_option": ApplicationEmploymentStatusOptions,
    "loanPurpose_option": ApplicationLoanPurposeOptions,
    "collateral_option": ApplicationCollateralOptions,
    "realEstate_option": ApplicationRealEstateOptions,
};
